module.exports = __webpack_public_path__ + "static/media/room-9.0cb5d5f0.jpg";